import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
    {
      id: 1,
      icon: (
        <svg width="60" height="60" viewBox="0 0 24 24" fill="#1a5d1a">
          <path d="M19 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H5V4h14v16z"/>
          <path d="M7 6h10v2H7zm0 4h10v2H7zm0 4h7v2H7z"/>
        </svg>
      ),
      title: 'Greenhouse Installation',
      description: 'Setup and Support'
    },
    {
      id: 2,
      icon: (
        <svg width="60" height="60" viewBox="0 0 24 24" fill="#1a5d1a">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
        </svg>
      ),
      title: 'Pest Control',
      description: 'Professional Solutions'
    },
    {
      id: 3,
      icon: (
        <svg width="60" height="60" viewBox="0 0 24 24" fill="#1a5d1a">
          <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
        </svg>
      ),
      title: 'Delivery Service',
      description: 'Fast & Reliable'
    }
  ];

  return (
    <section className="services-section">
      <div className="services-container">
        <h2 className="section-title">Our Services</h2>
        
        <div className="services-grid">
          {services.map(service => (
            <div key={service.id} className="service-card">
              <div className="service-icon-wrapper">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
        
        <div className="services-cta">
          <button className="learn-more-btn">Learn More &gt;</button>
        </div>
      </div>
    </section>
  );
};

export default Services;
